export const SET_VENDOR_CONTACTS = 'SET_VENDOR_CONTACTS'
export const SET_SAVED_VENDOR = 'SET_SAVED_VENDOR'
